import React from 'react'

import CircularLoaderV2 from '../../CircularLoaderV2/CircularLoaderV2'


const TableRowLoading = (props) => {
  const { style } = props
  return (
    <div
      className="Table__loader Table__loader--inline"
      style={style}>
      <CircularLoaderV2 size="small" />
    </div>
  )
}


export default TableRowLoading